import React from 'react';
import PriorityBadge from './PriorityBadge';
import { formatCurrency, formatScore } from '../lib/capacityPlanningFormatters';

const ExpansionCandidateTable = ({ items = [], onOpenDetail }) => {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-800 bg-slate-900/80">
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs text-slate-200">
          <thead className="bg-slate-950/80 text-[11px] uppercase tracking-wide text-slate-400">
            <tr>
              <th className="px-3 py-2 text-left">Kandidat</th>
              <th className="px-3 py-2 text-left">Scope</th>
              <th className="px-3 py-2 text-left">Prioritas</th>
              <th className="px-3 py-2 text-right">Urgensi</th>
              <th className="px-3 py-2 text-right">Demand</th>
              <th className="px-3 py-2 text-right">Capacity</th>
              <th className="px-3 py-2 text-right">Risk</th>
              <th className="px-3 py-2 text-right">Revenue</th>
              <th className="px-3 py-2 text-left">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td className="px-3 py-5 text-center text-slate-500" colSpan={9}>Tidak ada kandidat.</td>
              </tr>
            ) : items.map((item) => (
              <tr key={item.candidateId} className="border-t border-slate-800 hover:bg-slate-950/60">
                <td className="px-3 py-2">
                  <p className="font-medium text-slate-100">{item.title}</p>
                  <p className="text-[11px] text-slate-500">{item.areaName || '-'}</p>
                </td>
                <td className="px-3 py-2">{item.scopeType} • {item.scopeKey}</td>
                <td className="px-3 py-2"><PriorityBadge priority={item.priorityClass} /></td>
                <td className="px-3 py-2 text-right">{formatScore(item.urgencyScore)}</td>
                <td className="px-3 py-2 text-right">{formatScore(item.demandPressureScore)}</td>
                <td className="px-3 py-2 text-right">{formatScore(item.capacityPressureScore)}</td>
                <td className="px-3 py-2 text-right">{formatScore(item.serviceRiskScore)}</td>
                <td className="px-3 py-2 text-right">{formatCurrency(item.estimatedRevenueOpportunity)}</td>
                <td className="px-3 py-2">
                  <button
                    type="button"
                    onClick={() => onOpenDetail?.(item)}
                    className="rounded border border-slate-700 px-2 py-1 text-[11px] text-slate-200 hover:bg-slate-800"
                  >
                    Detail
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExpansionCandidateTable;
